import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { themeButtons } from "../../../css/themeButtons";


const SignUpConfirmRedirect = ({ userIsAuth, registrationType }) => {

  const history = useHistory();
  const [reachGoal, setReachGoal] = useState(false);
  const redirectToNewObject = () => {
    if (window.hasOwnProperty('ym') !== false && !reachGoal) {
      setReachGoal(true);
      window.ym(43381884, 'reachGoal', registrationType);
      window.ym(43381884, 'reachGoal', 'reg');
    }
    history.push('/lk/newObject')
  }

  const [ticks, setTicks] = useState(5);


  useEffect(() => {
    let timer = setTimeout(() => {
      setTicks(ticks - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [ticks]);


  useEffect(() => {
    let timer = null
    if (userIsAuth) {
      timer = setTimeout(() => {
        redirectToNewObject()
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [userIsAuth]);


  const buttons = themeButtons();
  return (
    <div className="main ps-0">
      <div className="container-fluid">
        <div className="w-100 mt-5 text-center">
          <h5 className="mb-3">Регистрация прошла успешно!</h5>
          <Typography className="mb-2" variant="body2" display="block">
            Нажмите продолжить или подождите и
            через {ticks} {ticks === 5 ? "секунд" : ticks < 5 && ticks > 1 ? "секунды" : "секунду"} мы
            перенаправим Вас на добавление объекта
          </Typography>
          <Button className={`btn ${buttons.btnGreen}`} onClick={redirectToNewObject}
                  variant="contained">Продолжить</Button>

        </div>

      </div>
    </div>
  )
}


export default SignUpConfirmRedirect
